import { isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { fetchAIAccessSettings } from '../../../../api/aiAccessSettingsApi';
const useFetchIsAIEnabledFromSettings = () => {
  const isAIAccessSettingsV2Fetch = useAsyncFetcher({
    fetcher: fetchAIAccessSettings
  });
  if (isSucceeded(isAIAccessSettingsV2Fetch)) {
    var _isAIAccessSettingsV, _isAIAccessSettingsV2;
    return ((_isAIAccessSettingsV = isAIAccessSettingsV2Fetch.data) === null || _isAIAccessSettingsV === void 0 ? void 0 : _isAIAccessSettingsV.generativeAiEnabled) && ((_isAIAccessSettingsV2 = isAIAccessSettingsV2Fetch.data) === null || _isAIAccessSettingsV2 === void 0 ? void 0 : _isAIAccessSettingsV2.crmPropertiesEnabled);
  }
  return undefined;
};
export default useFetchIsAIEnabledFromSettings;